// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"3c510dda4016cef4","5405":"b5fb43b1cd7cd9bc"}[chunkId] + ".css";
};